var makeString = require('./helper/makeString');

module.exports = function chars(str) {
  return makeString(str).split('');
};



//////////////////
// WEBPACK FOOTER
// ./~/underscore.string/chars.js
// module id = ygxB
// module chunks = 0